import React from 'react'
import { Button } from '@mui/material'
import moment from 'moment'
import { useAnalyticsFilters } from '../../../contexts/AnalyticsFilterContext'
import { FilterBar, FilterField } from '../styles'

const DateRangeFilter = ({ showGranularity = false, showWorkshopId = false }) => {
    const { startDate, setStartDate, endDate, setEndDate, workshopId, setWorkshopId, granularity, setGranularity } =
        useAnalyticsFilters()

    const resetLast30Days = () => {
        setEndDate(moment().format('YYYY-MM-DD'))
        setStartDate(moment().subtract(29, 'days').format('YYYY-MM-DD'))
    }

    return (
        <FilterBar>
            <FilterField>
                <label htmlFor='analytics-start-date'>Data início</label>
                <input
                    id='analytics-start-date'
                    type='date'
                    value={startDate}
                    max={endDate}
                    onChange={(e) => setStartDate(e.target.value)}
                />
            </FilterField>
            <FilterField>
                <label htmlFor='analytics-end-date'>Data fim</label>
                <input
                    id='analytics-end-date'
                    type='date'
                    value={endDate}
                    min={startDate}
                    onChange={(e) => setEndDate(e.target.value)}
                />
            </FilterField>
            {showGranularity && (
                <FilterField>
                    <label htmlFor='analytics-granularity'>Granularidade</label>
                    <select
                        id='analytics-granularity'
                        value={granularity}
                        onChange={(e) => setGranularity(e.target.value)}
                    >
                        <option value='day'>Dia</option>
                        <option value='week'>Semana</option>
                        <option value='month'>Mês</option>
                    </select>
                </FilterField>
            )}
            {showWorkshopId && (
                <FilterField>
                    <label htmlFor='analytics-workshop-id'>ID da oficina (opcional)</label>
                    <input
                        id='analytics-workshop-id'
                        type='number'
                        min='1'
                        placeholder='ex: 1000001'
                        value={workshopId}
                        onChange={(e) => setWorkshopId(e.target.value)}
                    />
                </FilterField>
            )}
            <Button variant='outlined' size='small' onClick={resetLast30Days}>
                Últimos 30 dias
            </Button>
        </FilterBar>
    )
}

export default DateRangeFilter
